import { useContext } from 'react';
import PaginationOffsetContext from 'contexts/PaginationOffset/PaginationOffsetContext';

export default function usePagination() {
    const { page, onPageChange } = useContext(PaginationOffsetContext);

    return [page, onPageChange];
}
